<template>
  <div style="width: fit-content">
    <div style="display: flex">
      <el-form :disabled="disabled" label-position="right" label-width="100px" style="display: flex;">
        <div v-for="(item, index) in upElementBlocks" :key="index" class="section form-column" :style="{width: item.width + 'px'}">
          <span class="title">{{ item.title }}</span>
          <slot v-for="elementName in item.elementNames" :name="elementName" />
        </div>
      </el-form>
    </div>
    <template v-if="!!downElementBlock">
      <slot v-for="elementName in downElementBlock.elementNames" :name="elementName" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'TabSubBillUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true },
    disabled: { type: Boolean, required: true }
  },
  computed: {
    upElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 1 && !p.hide)
    },
    downElementBlock() {
      return this.elementBlocks.find(p => p.position === 2 && !p.hide)
    }
  }
}
</script>
